import { z } from "@/zod";
import { time } from "./commonFields/time";
import { dateTime } from "./commonFields/dateTime";
import { NUMBER_SCHEMA } from "./commonFields/numberSchema";

export const timesheetEntryShiftReport = z.object({
  id: z.string().min(26),
  shift_report_id: z.string().min(26),
  start_datetime: dateTime,
  end_datetime: dateTime,
  store_id: z.string().min(26),
  hours_total: z.number().nonnegative(),
  break_time: time,
  break_hours: z.number().nonnegative(),
  hours_without_break: z.number().nonnegative(),
  contractor_id: z.string().min(26),
  contractor_name: z.string(),
  payroll_department_name: z.string(),
  full_time_equivalent: z.number().nonnegative().describe(NUMBER_SCHEMA),
  payroll: z.string(),
});

export const readTimesheetEntryShiftReport =
  timesheetEntryShiftReport.readonly();
